import { EventBus } from '@/store/EventBus.js'
import AsyncComputed from 'vue-async-computed'
import vueSignature from 'vue-signature'
import VueScrollTo from 'vue-scrollto'
import IdleVue from 'idle-vue'
import Meta from 'vue-meta'
import store from '../store'
import Vue from 'vue'

Vue.use(AsyncComputed)
Vue.use(vueSignature)
Vue.use(VueScrollTo)
Vue.use(Meta)
Vue.use(IdleVue, {
  startAtIdle: false,
  store,
  eventEmitter: EventBus,
  idleTime: 60000
})

// v-if-cliente
Vue.directive('if-cliente', {
  inserted (el, binding, vnode, old) {
    if (!store.getters.Cliente) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})
// v-if-tecnico
Vue.directive('if-tecnico', {
  inserted (el, binding, vnode, old) {
    if (!store.getters.Tecnico) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})
